import { Component, inject, OnInit } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { MessageService } from 'primeng/api';
import { HelperService } from '../../shared/services/helper.service';
import { Subscription } from 'rxjs';
import { environment } from '../../../environments/environment';
import { PageMetadataService } from '../../shared/services/page-metadata.service';
import { HttpService } from '../../shared/services/http.service';
import { SidebarService } from '../../shared/services/sidebar.service';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrl: './dashboard.component.css',
})
export class DashboardComponent implements OnInit {
  memberListSubs!: Subscription;
  breadCrumbItems: MenuItem[] | undefined;
  breadCrumbHome: MenuItem | undefined;
  httpService = inject(HttpService);
  helper = inject(HelperService);
  pageMetaData= inject(PageMetadataService);
  sidebar= inject(SidebarService);

  
  isWpDashboardTask: boolean = true;
  dashboardCount: any;
  tabIndex = 0;
  activeTab = 0;
  xAxisLabels: any=[];
  themeValues: any=[];
  themeColors:any=[];
  QThemeWise:boolean=false;
  barColors: any[];
  isGraphLoading:boolean=false;
  filterCount: number=0;
  isSidebarOpen: boolean=false;

  statusCard = [
    {
      title: 'Approval Pending',
      count: '01',
      iconName: 'hugeAlert02',
      iconColor: '#FF1F26',
      iconBoxColor: '#FF1F261a',
      selected: 'pending',
    },
    {
      title: 'Not Started',
      count: '01',
      iconName: 'hugeFolderRemove',
      iconColor: '#544f4f',
      iconBoxColor: '#544f4f1a',
      selected: 'notstarted',
    },
    {
      title: 'Ongoing',
      count: '01',
      iconName: 'hugeClock05',
      iconColor: '#FFAA00',
      iconBoxColor: '#FFAA001a',
      selected: 'ongoing',
    },
    {
      title: 'Closed',
      count: '01',
      iconName: 'hugeTaskDone01',
      iconColor: '#00B458',
      iconBoxColor: '#00B4581a',
      selected: 'closed',
    },
    {
      title: 'Rejected',
      count: '08',
      iconName: 'hugeCancelCircleHalfDot',
      iconColor: '#8C0000',
      iconBoxColor: '#8C00001a',
      selected: 'rejected',
    },
  ];
  themeData: any;
  seriesData: any[] = [];
  customLabels: any[] = [];
  QimpactGraph:boolean = false;
  impactSeriesData: any[] = [];
  teamMembersLists: any=[];
  filterData: any;
  impactColors:any[] = ['#0B41CD', '#4D75DD', '#9BB3EF'];
  private messageService: MessageService
  colors: any[] = ['#0B41CD', '#4D75DD', '#9BB3EF', '#FF6384', '#36A2EB'];    

  ngOnInit(): void {
    this.pageMetaData.setTitle('WP-Dashboard | OBP')
    this.helper.fetchMembersList("member",{include_members: this.helper.loggedInUser?.user_id}).subscribe((response)=>{
      this.teamMembersLists=response.data
      this.sidebar.selectedWPDashboardMember=response?.data?.find(
        (m: any) => m.user_id === this.helper.loggedInUser.user_id
      );
      this.filterCount =this.sidebar.selectedWPDashboardMember == null ? 0 :1 
      this.fetchDashboardCount({member_id:this.helper.loggedInUser.user_id});
    })
    this.fetchThemeData();
    this.fetchBrandData();
    this.fetchImpactData();
    this.breadCrumbItems = [{ label: 'Work Packages' }, { label: 'Dashboard' }];
    this.breadCrumbHome = { label: 'Home', routerLink: '/home' };
    
  }

  toggleSidebar() {
    this.isSidebarOpen = !this.isSidebarOpen;
  }

  wpDashboardTeamMembers(data:any){
    if (Array.isArray(data)) {
      const combined = [...this.teamMembersLists, ...data];
      this.teamMembersLists = Array.from(
        new Map(combined.map(member => [member.user_id, member])).values()
      );
    } else if (data && typeof data === "object" && "user_id" in data) {
      const index = this.teamMembersLists.findIndex(
        (member: any) => member.user_id === data.user_id
      );
    
      if (index !== -1) {
        this.teamMembersLists[index] = data;
      } else {
        this.teamMembersLists.push(data);
      }
    }
  }


  getFilledPropertiesCount(data:any) {
    return Object.keys(data).filter(
      (key) => data[key] !== null && data[key] !== '' && data[key]!=undefined
    )?.length;
  }

  myTaskSelection(filterData: any) {
    this.filterCount =this.sidebar.selectedWPDashboardMember == null ? 0 :1 
    this.filterData = filterData;
    this.fetchDashboardCount();
    this.fetchThemeData();
    this.fetchBrandData();
    this.fetchImpactData();
  }

  fetchDashboardCount(payload?:any){
    this.httpService
    .post(`${environment.opbBackendHost}/api/member/workpackage/dashboard/count`, {...this.filterData,...payload})
    .subscribe((res: any) => {
      this.dashboardCount = res?.data;
    });
  }

  fetchThemeData() {
  
    this.httpService
      .post(`${environment.opbBackendHost}/api/member/workpackage/graph/theme`, this.filterData)
      .subscribe((res: any) => {
        //this.themeData = res?.data;
        this.themeFields(res?.data);
      });
  }

  fetchBrandData() {
    this.isGraphLoading=true
    this.httpService
      .post(`${environment.opbBackendHost}/api/member/workpackage/graph/brand`, this.filterData)
      .subscribe((res: any) => {
        if(res?.code==200){
          if(res?.data){
            let data = res?.data;
            this.seriesData = data.map((item:any) => item.percentage);
            this.customLabels = data.map((item:any) => item.brand);
            if (this.customLabels.length > this.colors.length) {
              this.colors = [
                ...this.colors,
                ...this.generateAdditionalColors(
                  this.customLabels.length - this.colors.length
                ),
              ];
            }
          }
        }else{
        }
        this.isGraphLoading=false
      });
  }

  fetchImpactData() {
    this.QimpactGraph = true;
    this.httpService
      .post(`${environment.opbBackendHost}/api/member/workpackage/graph/area/impact`, this.filterData)
      .subscribe((res: any) => {
        if(res?.code==200){
          if(res?.data){
            this.impactSeriesData = [
              res?.data.affiliate,
              res?.data.cluster,
              res?.data.global
            ];
          }
        }else{
        }
        this.QimpactGraph = false;
      });
  }

  tabChange(e:any){
    if(e.index==0){
      this.fetchBrandData();
    }else if(e.index==1){
      this.fetchTherapiGraphData();
    }else if(e.index==2){
      this.fetchIndicationGraph();
    }
    this.activeTab = e.index;
  }

  fetchTherapiGraphData() {
    this.isGraphLoading=true
    this.httpService
      .post(`${environment.opbBackendHost}/api/member/workpackage/graph/area/therapeutic`, this.filterData)
      .subscribe((res: any) => {
        if(res?.code==200){
          if(res?.data){
            let data = res?.data
            this.seriesData = data.map((item:any) => item.percentage);
            this.customLabels = data.map((item:any) => item.therapeutic_area);
            this.customLabels.forEach((item: any) => {
              if (this.customLabels.length > this.colors.length) {
                this.colors = [
                  ...this.colors,
                  ...this.generateAdditionalColors(
                    this.customLabels.length - this.colors.length
                  ),
                ];
              }
      });
          }
        }else{
        }
        this.isGraphLoading=false
      });
      
  }

  fetchIndicationGraph() {
    this.isGraphLoading=true
    this.httpService
      .post(`${environment.opbBackendHost}/api/member/workpackage/graph/indication`, this.filterData)
      .subscribe((res: any) => {
        if(res?.code==200){
          if(res?.data){
            let data = res?.data
            this.seriesData = data.map((item:any) => item.percentage);
            this.customLabels = data.map((item:any) => item.indication);
            this.customLabels.forEach((item: any) => {
              if (this.customLabels.length > this.colors.length) {
                this.colors = [
                  ...this.colors,
                  ...this.generateAdditionalColors(
                    this.customLabels.length - this.colors.length
                  ),
                ];
              }

      });
          }
        }else{
        }
        this.isGraphLoading=false
      });
  }

  themeFields(themes:any[]) {
    if (themes && Array.isArray(themes)) {
      const themeData: any = [];
      const themeDataVal: any = [];
      const barColorVal: any = [];
        themes.forEach(theme => {
          themeData.push(theme.value); 
          themeDataVal.push(theme.workpackages_count); 
          barColorVal.push(theme.color); 
        });

        this.themeColors = [...themeData];
        this.themeValues = [...themeData];
        this.barColors = [...barColorVal];
        this.xAxisLabels = [...themeDataVal]
        this.QThemeWise = true;
      }
  }

  generateAdditionalColors(count: number): string[] {
    const additionalColors: string[] = [];
    for (let i = 0; i < count; i++) {
      additionalColors.push(
        `#${Math.floor(Math.random() * 16777215).toString(16)}`
      );
    }
    return additionalColors;
  }
}
